import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root',
})
export class MyHardCopyService {
  constructor(private httpClient: HttpClient) {}

  hardcopyActivityCompleted = new Subject<any>();

  public OnHardcopyActivityComplted(): Observable<any> {
    return this.hardcopyActivityCompleted.asObservable();
  }
  
  getMyHardCopyActivities(): Observable<any> {
    return this.httpClient.get(ApiConstants.MyHardCopyActivity_Api);
  }
}
